// export this package's api
import Align from './Align';

export default Align;


//////////////////
// WEBPACK FOOTER
// ../~/_rc-align@2.4.5@rc-align/es/index.js
// module id = 589
// module chunks = 0